import React from 'react';
import SafeIcon from '../common/SafeIcon';

const Footer = () => {
  return (
    <footer className="bg-charcoal-950 pt-20 pb-10 border-t border-white/10">
      <div className="container mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-3 gap-12 mb-16">
          
          {/* Column 1: Brand & CTA */}
          <div>
            <a href="#home" className="inline-block mb-6">
              <img 
                src="https://media-manager-c.questera.ai/greta-media/d334477e75b4fabb65d5be5423d2041faad258e6d76e6691f8155cb326e304c728474a3a46f4e57b3b2d456fd1aa0681/images/aW1hZ2UvanBlZw==/8828e18fef6fb00dc96be6d038a45d2a.jpg" 
                alt="Atlantic Real Estate Solutions" 
                className="h-16 md:h-20 w-auto object-contain rounded-md"
              />
            </a>
            <h3 className="text-gold-500 font-bold text-xl mb-4">Take Control of Your<br/>Valuation Needs Today</h3>
            <a href="#contact" className="inline-flex items-center text-white font-semibold text-sm hover:text-gold-500 transition-colors mt-2">
              Get Started <SafeIcon name="ArrowUpRight" className="ml-2" size={16} />
            </a>
            
            <div className="flex space-x-4 mt-8">
              <a href="https://www.facebook.com/people/Atlantic-Real-Estate-Solutions/61584528634771/" target="_blank" rel="noopener noreferrer" className="text-gold-500 hover:text-white transition-colors" aria-label="Facebook">
                <SafeIcon name="Facebook" size={20} />
              </a>
              <a href="https://www.instagram.com/atlanticrealestate_solutions/" target="_blank" rel="noopener noreferrer" className="text-gold-500 hover:text-white transition-colors" aria-label="Instagram">
                <SafeIcon name="Instagram" size={20} />
              </a>
              <a href="https://www.linkedin.com/company/atlantic-real-estate-solutions?trk=public_post_feed-actor-name" target="_blank" rel="noopener noreferrer" className="text-gold-500 hover:text-white transition-colors" aria-label="LinkedIn">
                <SafeIcon name="Linkedin" size={20} />
              </a>
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div>
            <h4 className="font-bold text-gold-500 mb-6 text-sm uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-3 text-sm text-gray-400">
              <li><a href="#home" className="hover:text-gold-500 transition-colors flex items-center gap-2"><div className="w-1 h-1 bg-gold-500 rounded-full"></div> Home</a></li>
              <li><a href="#about" className="hover:text-gold-500 transition-colors flex items-center gap-2"><div className="w-1 h-1 bg-gold-500 rounded-full"></div> Why Choose Us</a></li>
              <li><a href="#services" className="hover:text-gold-500 transition-colors flex items-center gap-2"><div className="w-1 h-1 bg-gold-500 rounded-full"></div> Services</a></li>
              <li><a href="#process" className="hover:text-gold-500 transition-colors flex items-center gap-2"><div className="w-1 h-1 bg-gold-500 rounded-full"></div> Process</a></li>
            </ul>
          </div>

          {/* Column 3: Contact Info */}
          <div>
            <h4 className="font-bold text-gold-500 mb-6 text-sm uppercase tracking-wider">Contact Info</h4>
            <ul className="space-y-6 text-sm text-gray-400">
              <li className="flex items-start gap-3">
                <SafeIcon name="Phone" className="text-gold-500 mt-1" size={16} />
                <div>
                  <span className="block text-white font-medium mb-1">Call us at:</span>
                  (555) 123-4567
                </div>
              </li>
              <li className="flex items-start gap-3">
                <SafeIcon name="Mail" className="text-gold-500 mt-1" size={16} />
                <div>
                  <span className="block text-white font-medium mb-1">Email us at:</span>
                  valuations@atlanticres.com
                </div>
              </li>
              <li className="flex items-start gap-3">
                <SafeIcon name="MapPin" className="text-gold-500 mt-1" size={16} />
                <div>
                  <span className="block text-white font-medium mb-1">Our Location:</span>
                  1000 Premium Ave, Suite 400<br/>Washington, DC 20001
                </div>
              </li>
            </ul>
            <p className="mt-6 text-xs text-gray-500 uppercase tracking-widest border-t border-white/5 pt-4">
              Providing MAI Certified Appraisals<br/>Across the East Coast
            </p>
          </div>

        </div>

        <div className="border-t border-white/10 pt-6 text-center text-xs text-gray-600">
          <p>Copyright &copy; {new Date().getFullYear()} Atlantic Real Estate Solutions. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;